<template lang="pug">
.warning-wall(:class="{ embed }"): main: .container.page-wrapper
    .page
        .body
            .content(v-if="warning")
                .message(v-html="warning")

            .actions
                button.btn.btn-primary.btn-medium.important(@click="accept" :class="{'embed-btn': embed}") {{ $t('registration.actions.warning_wall_accept') }}
                a.btn.btn-medium.important(v-if="rejectHref" :href="rejectHref" rel="noopener noreferrer" :class="{'embed-btn': embed}") {{ $t('registration.actions.warning_wall_reject') }}
</template>
<script>
// Utils
import { get, isEmpty } from 'lodash';

export default {
    name: 'WarningWall',

    props: {
        config: {
            type: Object,
            required: true
        },

        embed: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        const event = this.config.event_details || {};
        const defaultLocale = event.languages?.[0] || 'en';
        const wallConfig = event.warning_wall_config || {};
        const defaultWarning = get(wallConfig, `content.${defaultLocale}`, '');
        const defaultRejectHref = get(wallConfig, `redirect.${defaultLocale}`, '');

        return {
            wallConfig,
            defaultLocale,
            defaultWarning,
            defaultRejectHref
        }
    },

    computed: {
        warning() {
            let message = get(this.wallConfig, `content.${this.$i18n.locale}`);
            if (isEmpty(message)) {
                message = this.defaultWarning;
            }
            return message;
        },

        rejectHref() {
            let href = get(this.wallConfig, `redirect.${this.$i18n.locale}`);
            if (isEmpty(href)) {
                href = this.defaultRejectHref;
            }
            return href;
        }
    },

    methods: {
        accept() {
            const { branding, id } = this.$route.params;
            this.$services.storage.setItemWithPrefix(`${branding}_${id}`, 'warning_wall_ack', 1);
            this.$emit('accepted');
        }
    }
};
</script>
